module.exports = __webpack_public_path__ + "static/media/galeria_elo_14.28ace927.jpg";